<template>
  <div class="DropPromptCenter">
    <div v-show="isvisible" class="container-bg" @click.stop="handleClose">
      <div class="container">
        <div class="close"><img src="@/assets/icon_close.png" @click="handleClose"></div>
        <img class="content" :src="icon" @click="clickOpen(item)">
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 弹出框
 */
import { cblockItem } from '@/api/app'
import { getQueryObject } from '@/utils/index'
import { isPupo } from '@/api/vip'
import { umtrack } from '@/utils/uweb'
export default {
  name: 'DropPromptCenter',
  props: {
    list: {
      type: Array,
      default: () =>{
        return []
      }
    }
  },
  filters: {
  },
  watch: {
    list() {
      this.init()
    }
  },
  computed: {
    isvisible: function() {
      return this.visible&&this.showable
    }
  },
  created() {
    this.decideShowAble()
    this.init()
  },
  data () {
    return {
      key: 'vip-center-popup',
      icon: '',
      item: {},
      visible: false,
      showable: false,
      expired: 3600000
    }
  },
  methods: {
    init(){
      if(this.list.length > 0 && this.list[0].hasOwnProperty('icon')){
        this.item = this.list[0]
        this.icon = this.list[0].icon
        this.visible = true
      }else{
        this.visible = false
      }
    },
    decideShowAble(){
      const key = 'center-vip-popup'
      var expired = sessionStorage.getItem(key)
      var current = new Date().getTime()
      if(expired && expired > current){
        this.showable = false
        return
      }
      if(this.list.length > 0){
        const params = getQueryObject(this.list[0].redirect)
        if(params.hasOwnProperty('code')){
          isPupo({code: params.code}).then(response => {
            this.showable = response.data.data
            if(this.showable) {
              umtrack('vip-pupo', {}, this)
              sessionStorage.setItem(key, current+this.expired)
            }
          })
        }
      }
    },
    handleClose() {
      this.visible = false
    },
    clickOpen: function(item){
      cblockItem(item, this)
      this.visible = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.DropPromptCenter{
  .container-bg{
    position:fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    .close{
      text-align: right;
      img{
        vertical-align: bottom;
      }
    }
    .container{
        animation: drop 2s cubic-bezier(.1,.25,1,.25) forwards;
        width: 80vw;
        .content{
            width: 100%;
        }
    }
  }
}
@keyframes drop{
    from{
        transform: translateY(-100%);
    }
    60%, 80%, to {
        transform: translateY(0);
        animation-timing-function: ease;
    }
    70% { transform: translateY(-30%);}
    90% { transform: translateY(-10%);}
}
</style>
